import { Component, effect } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { INavigationFlatTreenode } from 'src/app/types/infrastructure/interfaces/INavigationFlatTreenode';
import { DataService } from 'src/app/services/data.service';
import { AppstateService } from 'src/app/services/appstate.service';
import { TreeService } from 'src/app/services/controls/tree.service';

@Component({
  selector: 'app-archiv-tree',
  templateUrl: './archiv-tree.component.html',
  styleUrl: './archiv-tree.component.css'
})
export class ArchivTreeComponent {
  
  public treeControl = new FlatTreeControl<INavigationFlatTreenode>( node => node.level, node => node.expandable, );
  public dataSource = new MatTreeFlatDataSource(this.treeControl, new MatTreeFlattener(this.treeService.transformTreenodeData, node => node.level, node => node.expandable, node => node.children ));

  constructor(public appStateService: AppstateService,
              private treeService: TreeService,
              private dataservice: DataService) {

    effect(() => {
      this.dataSource.data = this.dataservice.archivTreeNodes();
      this.treeControl.expandAll();
    });
  }
            
  ngOnInit() {
    this.appStateService.archivTreeInit.set(true);
  }
              
  hasChild(_: number, node: INavigationFlatTreenode) { 
    return node.expandable; 
  }

  onClick(value: string) {
    this.appStateService.navigationBereich.set(value);
  }
}
